import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './contexts/AuthContext';
import FloatingPlane from './components/feature/FloatingPlane';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AppRoutes />
        <FloatingPlane />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
